import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import Project from '../../components/organisms/Project/Project'
import Spinner from '../../components/atoms/Spinner/Spinner'
import { FETCH_PROJECT } from '../../actions/projectActions'
import ModalError from '../../components/molecules/ErrorModal/ModalError'

import './TopPage.css'

class TopPage extends PureComponent {
  componentDidMount() {
    const { fetchProject } = this.props
    fetchProject()
  }

  render() {
    const { title, isShowModalError, errorMessage } = this.props

    if (isShowModalError) {
      return <ModalError message={errorMessage} />
    }

    // fetch成功前
    if (title == null) {
      return (
        <div styleName="spinner">
          <Spinner />
        </div>
      )
    }

    return (
      <div styleName="appContainer">
        <Project />
      </div>
    )
  }
}

TopPage.propTypes = {
  // state
  title: PropTypes.string,
  errorMessage: PropTypes.string,
  isShowModalError: PropTypes.bool.isRequired,
  // dispatch
  fetchProject: PropTypes.func.isRequired
}

const mapStateToProps = state => ({
  title: state.projects.title,
  errorMessage: state.notice.modalErrorMessage,
  isShowModalError: state.notice.isShowModalError
})

const mapDispatchToProps = dispatch => ({
  fetchProject: () => dispatch(FETCH_PROJECT())
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TopPage)
